import { z } from "zod";

export const cartItemSchema = z.object({
  productId: z.string().uuid(),
  sku: z.string().min(1).max(80),
  name: z.string().min(1).max(180),
  quantity: z.number().int().min(1).max(999),
  salePrice: z.number().nonnegative(),
  wholesalePrice: z.number().nonnegative().nullable(),
  wholesaleMinQuantity: z.number().int().positive().nullable(),
  currencyCode: z.string().min(3).max(3),
});

export type CartItem = z.infer<typeof cartItemSchema>;

export const sessionCartItemSchema = cartItemSchema.extend({
  slug: z.string().min(1).max(120),
  imageUrl: z.string().nullable(),
  familyName: z.string().min(1).max(160),
  brandName: z.string().min(1).max(120).nullable(),
  type: z.enum(["original", "generico"]),
  availability: z.enum(["available", "check_stock", "out_of_stock", "coming_soon"]),
});

export type SessionCartItem = z.infer<typeof sessionCartItemSchema>;

export interface CartTotals {
  readonly subtotalRetail: number;
  readonly subtotalEstimated: number;
  readonly wholesaleDiscount: number;
  readonly shippingAmount: number;
  readonly total: number;
  readonly currencyCode: string | null;
  readonly itemCount: number;
  readonly isWholesaleOrder: boolean;
}
